var React = require('react');

function Listing (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.764 8.615V14a.538.538 0 0 1-.539.538h-1.27A.538.538 0 0 1 5.417 14V8.615h-4.34A1.077 1.077 0 0 1 0 7.538V1.077C0 .482.482 0 1.077 0h10.846C12.518 0 13 .482 13 1.077v6.461c0 .595-.482 1.077-1.077 1.077h-4.16zm2.764-6.104a.538.538 0 0 0-.678-.345L2.365 4.598a.538.538 0 0 0-.345.678l.285.878a.538.538 0 0 0 .678.346l7.485-2.432a.538.538 0 0 0 .346-.679l-.286-.878z","fill":"#424242","fillRule":"evenodd"}));
}

Listing.defaultProps = {"width":"13","height":"15","viewBox":"0 0 13 15"};

module.exports = Listing;

Listing.default = Listing;
